import moment from "moment";

const formatDate = (time?: string | number) => {
  if (!time) {
    return "";
  }
  moment.updateLocale("en", {
    calendar: {
      sameDay: "[今天]HH:mm",
      nextDay: "[明天]HH:mm",
      nextWeek: "M.D HH:mm",
      lastDay: "M.D HH:mm",
      lastWeek: "M.D HH:mm",
      sameElse() {
        return "M.D HH:mm";
      },
    },
  });
  return moment(Number(time)).calendar();
};

const isSameDay = (time1: number, time2: number) => {
  const date1 = new Date(time1);
  const date2 = new Date(time2);
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

 const formatTimeAgo = (createTimeStamp, systemTimeStamp) => {
  const diffMillis = Number(systemTimeStamp) - Number(createTimeStamp);

  // 小于1分钟
  if (diffMillis < 60 * 1000) {
    return "刚刚";
  }

  // 大于等于1分钟小于60分钟
  if (diffMillis < 60 * 60 * 1000) {
    const minutes = Math.floor(diffMillis / (60 * 1000));
    return `${minutes}分钟前`;
  }

  // 大于等于60分钟小于24小时
  if (diffMillis < 24 * 60 * 60 * 1000) {
    const hours = Math.floor(diffMillis / (60 * 60 * 1000));
    return `${hours}小时前`;
  }

  // 大于等于24小时小于等于72小时
  if (diffMillis < 72 * 60 * 60 * 1000) {
    const days = Math.floor(diffMillis / (24 * 60 * 60 * 1000));
    return `${days}天前`;
  }

  // 大于72小时
  const date = new Date(Number(createTimeStamp));
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const nowYear = new Date().getFullYear();
  if (year === nowYear) {
    return `${month}-${day}`;
  }
  return `${year}-${month}-${day}`;
};

export { formatDate, formatTimeAgo, isSameDay };

